import React from "react";
import PropTypes from "prop-types";
import { cn } from "../../utils/classNames";

const variantClasses = {
  display: "text-display",
  h1: "text-h1",
  h2: "text-h2", 
  h3: "text-h3",
  h4: "text-h4",
  h5: "text-h5",
  "footer-heading": "text-footer-heading",
  "body-large": "text-body-large",
  body: "text-body",
  "body-small": "text-body-small",
  caption: "text-caption",
};

const defaultElements = {
  display: "h1",
  h1: "h1",
  h2: "h2",
  h3: "h3", 
  h4: "h4",
  h5: "h5",
  "footer-heading": "h5",
  "body-large": "p",
  body: "p",
  "body-small": "p",
  caption: "span",
};

const Typography = React.forwardRef(
  ({ 
    variant = "body", 
    as, 
    className, 
    children, 
    ...props 
  }, ref) => {
    const Component = as || defaultElements[variant] || "p";
    
    return (
      <Component
        ref={ref}
        className={cn(
          variantClasses[variant],
          "text-foreground",
          className
        )}
        {...props}
      >
        {children}
      </Component>
    );
  }
);

Typography.displayName = "Typography";

Typography.propTypes = {
  variant: PropTypes.oneOf([
    "display",
    "h1",
    "h2", 
    "h3",
    "h4",
    "h5",
    "footer-heading",
    "body-large",
    "body",
    "body-small",
    "caption",
  ]),
  as: PropTypes.elementType,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Typography;
